<template>
  <div class>
    <ul class="news-content" slot="item">
      <li v-for="(item, index) in newsList" :key="index" @click="onItem(item)">
        <img :src="item.thumb_img" />
        <div>
          <p class="name">{{ item.title }}</p>
          <p class="desc">{{ item.description }}</p>
          <div>
            <p class="number">{{ item.click_rate }}</p>
            <p class="time">{{ item.created_at | fomartTime("yyyy/MM/dd hh:mm") }}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    newsList: {
      default: []
    }
  },
  methods: {
    onItem(item) {
      if (this.$store.state.app) {
        this.$pub.appJump(`/news-detail?id=${item.id}`);
      } else {
        this.$router.push({
          name: "NewsDetail",
          query: {
            id: item.id
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.news-content {
  padding: 30px;
  li {
    padding: 20px;
    margin-bottom: 30px;
    background: #fff;
    box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.07);
    border-radius: 20px;
    display: flex;
    align-items: center;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      display: block;
      width: 208px;
      height: 129px;
      border-radius: 10px;
      flex: none;
      margin-right: 24px;
    }
    & > div {
      overflow: hidden;
      flex: 1;
      .name {
        @include eps;
        margin-bottom: 20px;
        font-size: 28px;
        line-height: 32px;
        font-weight: 500;
        color: #333;
      }
      .desc {
        @include eps;
        // height: 60px;
        width: 100%;
        font-size: 24px;
        color: #999;
        line-height: 30px;
      }
      div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 35px;
        p {
          font-size: 22px;
          color: #999;
          line-height: 22px;
        }
        .number {
          padding: 0 0 0 34px;
          background: url("~@/assets/images/icon-eye.png") left center no-repeat;
          background-size: 25px 17px;
        }
        .time {
          padding: 0 0 0 26px;
          background: url("~@/assets/images/icon-time.png") left center
            no-repeat;
          background-size: 17px 17px;
        }
      }
    }
  }
}
</style>
